import React from 'react';
import { useTranslation } from 'react-i18next';
import { useFormContext } from 'react-hook-form';
import { useWarehouseContext } from './warehouse-context';
import {
  ButtonComponent,
  ButtonStyling,
} from '../../../../components/form/elements/button';
import css from '../index.module.css';

const WarehousePartyNumber = () => {
  const { t } = useTranslation();
  const { getValues } = useFormContext();
  const { setIsWarehouseModalOpen } = useWarehouseContext();

  const list = getValues('product_warehouses');
  const unit = getValues('unit');

  const isOneSet = !!list?.[0]?.warehouse_id?.label;

  return (
    <div className={css['party_number_main_body']}>
      <div className={css['party_number_main_body_list']}>
        {isOneSet &&
          list?.map((elem) => (
            <h1>{`${elem?.warehouse_id?.label || ''} - ${
              elem?.party_number?.value || ''
            } (${elem?.amount || ''} ${unit?.value || ''})`}</h1>
          ))}
      </div>
      {list?.length > 0 && (
        <hr className={css['party_number_main_body_list_line']} />
      )}

      <ButtonComponent
        name="open_warehouse"
        click={() => setIsWarehouseModalOpen(true)}
        label={t('pages.warehouse.deals.warehouse_party_number')}
        styling={ButtonStyling.cancel}
        ignoreValidation
      />
    </div>
  );
};

export default WarehousePartyNumber;
